import PropTypes from 'prop-types';
import VizExIconButton from 'visitor-ui-component-library/button/VizExIconButton';
import VizExIcon from 'visitor-ui-component-library/icon/VizExIcon';
import SVGMicrophone from 'visitor-ui-component-library-icons/icons/SVGMicrophone';
import VizExLoadingSpinner from 'visitor-ui-component-library/loading/VizExLoadingSpinner';
import I18n from 'I18n';
import { CANDY_APPLE, OLAF } from 'visitor-ui-component-library/constants/WidgetColors';
import { postMicButtonClickEvent } from '../actions/postMicButtonClickEvent';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MicrophoneButton = ({
  disabled = false,
  speechRecordingStatus = 'idle',
  speechPocActive = false,
  mobile = false
}) => {
  if (!speechPocActive) {
    return null;
  }
  const handleClick = () => {
    postMicButtonClickEvent();
  };
  const isDisabled = disabled || speechRecordingStatus === 'loading';
  const isRecording = speechRecordingStatus === 'recording';
  const buttonUse = isRecording ? 'primary' : 'transparent-on-background';
  const buttonWrapperStyle = {
    position: 'relative'
  };
  const recordingIndicatorStyle = {
    position: 'absolute',
    bottom: '2px',
    right: '2px',
    width: '8px',
    height: '8px',
    backgroundColor: CANDY_APPLE,
    borderRadius: '50%',
    border: `1px solid ${OLAF}`,
    opacity: isRecording ? 1 : 0,
    animation: isRecording ? 'microphoneRecordingBlink 1s infinite ease-in-out' : 'none'
  };
  return /*#__PURE__*/_jsx("div", {
    className: mobile ? 'm-right-3' : "",
    children: /*#__PURE__*/_jsxs("div", {
      style: buttonWrapperStyle,
      children: [/*#__PURE__*/_jsx(VizExIconButton, {
        disabled: isDisabled,
        onClick: handleClick,
        use: buttonUse,
        "aria-label": I18n.text('conversations-visitor-ui.visitorExperienceAriaLabels.microphone'),
        shape: "circle",
        "data-test-id": "MicrophoneButton-VizExIconButton",
        children: speechRecordingStatus === 'loading' ? /*#__PURE__*/_jsx(VizExLoadingSpinner, {
          size: "xs",
          use: "primary"
        }) : /*#__PURE__*/_jsx(VizExIcon, {
          icon: /*#__PURE__*/_jsx(SVGMicrophone, {})
        })
      }), /*#__PURE__*/_jsx("div", {
        style: recordingIndicatorStyle
      })]
    })
  });
};
MicrophoneButton.displayName = 'MicrophoneButton';
MicrophoneButton.propTypes = {
  disabled: PropTypes.bool,
  mobile: PropTypes.bool,
  speechPocActive: PropTypes.bool,
  speechRecordingStatus: PropTypes.oneOf(['idle', 'recording', 'loading'])
};
export default MicrophoneButton;